import { Component } from '@angular/core';
// import { ToasterConfig, ToasterService } from 'angular2-toaster';

@Component({
  selector: 'app-layout',
  templateUrl: './auth-layout.component.html'
})
export class AuthLayoutComponent {
 }
